export default "__VITE_ASSET__Ox5ECNb6__"